<template>
  <div class="c-alertPos c-text--center">
    <Button
      variant="main"
      size="w230"
      fsize="f16"
      :class="{ 'is-loading': isProcessing }"
      :disabled="isDisabled"
      @click="authGa4"
    >
      GA4と連携する
    </Button>
    <Alert v-if="errorResponse" variant="center">
      {{ errorResponse }}
    </Alert>
  </div>
</template>

<script>
import { ERROR_MESSAGE } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button
  },
  data() {
    return {
      errorResponse: '',
      timeoutId: null,
      isProcessing: false
    };
  },
  computed: {
    isDisabled() {
      return this.disabled || this.isProcessing;
    }
  },
  created() {
    this.$store.dispatch('set/resetGA4');
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    authGa4() {
      if (this.isDisabled) {
        return;
      }
      this.isProcessing = true;
      this.errorResponse = '';

      this.setTmpKey()
        .then(tmpKey => {
          const params = { tmpKey };
          this.$store.dispatch('set/setGA4Params', params);

          apiProjects.authorization.ga4.redirect(
            this.auth.idToken,
            this.project.id,
            tmpKey
          );
        })
        .catch(error => {
          this.errorResponse = ERROR_MESSAGE.other;
          this.isProcessing = false;

          // 失敗時のエラーメッセージを消すのに丁度いいトリガーがないので、3秒後に消すようにする
          this.timeoutId = setTimeout(() => {
            this.errorResponse = '';
          }, 3000);
        });
    },

    setTmpKey() {
      return new Promise((resolve, reject) => {
        this.auth
          .getUserData()
          .then(response => {
            let tmpKey = utils.getTmpKey();

            if (process.env.VUE_APP_ENV === 'local') {
              tmpKey = '6276261377';
            }

            const metaData = response.data.user_metadata;

            // projects内の不要なデータを削除する
            if (metaData.projects) {
              // projectIdとprojectNameがあるprojectだけ残す
              metaData.projects = metaData.projects.filter(item => {
                if (item.projectId && item.projectName) {
                  return true;
                }
              });
            } else {
              // projectsがなかったら配列を追加する
              metaData.projects = [];
            }

            // tmpKeyとprojectIdだけの新しいオブジェクトを追加する
            metaData.projects.push({ projectId: this.project.id, tmpKey });

            const data = {
              user_metadata: metaData
            };

            this.auth
              .updateUserData(data)
              .then(() => {
                resolve(tmpKey);
              })
              .catch(error => {
                reject(error);
              });
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
</script>
